"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType["PROFILE_QUESTIONNAIRES_READY_EVENT"] = "ProfileQuestionnairesReadyEvent";
    EventType["PROFILE_QUESTIONNAIRES_ANSWER_CHANGED_EVENT"] = "ProfileQuestionnairesAnswerChangedEvent";
    EventType["PROFILE_QUESTIONNAIRES_CPI_MODAL_CLOSED"] = "ProfileQuestionnairesCpiModalClosed";
    EventType["PROFILE_QUESTIONNAIRES_CPI_FILTERS"] = "ProfileQuestionnairesCPIFilters";
    EventType["PROFILE_QUESTIONNAIRES_BESTFIT_AI_EVENT"] = "ProfileQuestionnaireBestFitAIEvent";
})(EventType || (exports.EventType = EventType = {}));
